import { createSlice } from "@reduxjs/toolkit";

const updateperfiltState = {
  provincia: "",
  ciudad: "",
  sector: "",
  telefono: "",
  whatsapp: "",
};

const updateperfiltSlice = createSlice({
  name: "updateperfilt",
  initialState: updateperfiltState,
  reducers: {
    UpdateDataPerfil: (state, actions) => {
      state.provincia = actions.payload.provincia;
      state.ciudad = actions.payload.ciudad;
      state.sector = actions.payload.sector;
      state.telefono = actions.payload.telefono;
      state.whatsapp = actions.payload.whatsapp;
    },
    UpdateProvinciaPerfil: (state, actions) => {
      state.provincia = actions.payload.provincia;
    },
    UpdateCiudadPerfil: (state, actions) => {
      state.ciudad = actions.payload.ciudad;
    },
  },
});

export const { UpdateDataPerfil, UpdateProvinciaPerfil, UpdateCiudadPerfil } = updateperfiltSlice.actions;

export default updateperfiltSlice.reducer;
